import { createFromIconfontCN } from '@ant-design/icons';
// import * as Sentry from '@sentry/react';
// import SentryRRWeb from '@sentry/rrweb';
// import { Integrations } from '@sentry/tracing';
import { Button, message, notification } from 'antd';
import defaultSettings from '../config/defaultSettings';
// import { IS_OPEN_SENTRY } from './constant';
const { pwa } = defaultSettings;
const isHttps = document.location.protocol === 'https:';
export const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4978232_lm617n901hn.js', // 在 iconfont.cn 上生成 20250718更新
  // scriptUrl: '//at.alicdn.com/t/c/font_4738133_3yy0h4lvoe.js', // 在 iconfont.cn 上生成
});
// if (IS_OPEN_SENTRY) {
//   Sentry.init({
//     dsn: 'https://86c557c02edc4c84b2e61f976c520cf2@sentry.yishouapp.com/9',
//     autoSessionTracking: true,
//     ignoreErrors: [
//       // network errors
//       'ResizeObserver loop limit exceeded',
//       'Network request failed',
//       'Failed to fetch',
//       'NetworkError',
//       'ChunkLoadError',
//       'Network Error',
//     ],
//     integrations: [
//       new Integrations.BrowserTracing(),
//       new SentryRRWeb({
//         // checkoutEveryNth: 500,
//         sampling: {
//           // set the interval of scrolling event
//           scroll: 150, // do not emit twice in 150ms
//           // set the interval of media interaction event
//           media: 800,
//           // set the timing of record input
//           input: 'last', // When input multiple characters, only record the final input
//         },
//       }),
//     ],
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
//   });
// }
const clearCache = () => {
  // remove all caches
  if (window.caches) {
    caches
      .keys()
      .then((keys) => {
        keys.forEach((key) => {
          caches.delete(key);
        });
      })
      .catch((e) => console.log(e));
  }
};

// if pwa is true
if (pwa) {
  // Notify user if offline now
  window.addEventListener('sw.offline', () => {
    message.warning('当前处于离线状态');
  });

  // Pop up a prompt on the page asking the user if they want to use the latest version
  window.addEventListener('sw.updated', (event: Event) => {
    const e = event as CustomEvent;
    const reloadSW = async () => {
      // Check if there is sw whose state is waiting in ServiceWorkerRegistration
      // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
      const worker = e.detail && e.detail.waiting;
      if (!worker) {
        return true;
      }
      // Send skip-waiting event to waiting SW with MessageChannel
      await new Promise((resolve, reject) => {
        const channel = new MessageChannel();
        channel.port1.onmessage = (msgEvent) => {
          if (msgEvent.data.error) {
            reject(msgEvent.data.error);
          } else {
            resolve(msgEvent.data);
          }
        };
        worker.postMessage({ type: 'skip-waiting' }, [channel.port2]);
      });

      clearCache();
      window.location.reload();
      return true;
    };
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type="primary"
        onClick={() => {
          notification.close(key);
          reloadSW();
        }}
      >
        刷新
      </Button>
    );
    notification.open({
      message: '有新内容',
      description: '请点击“刷新”按钮或者手动刷新页面',
      btn,
      key,
      onClose: async () => null,
    });
  });
} else if ('serviceWorker' in navigator && isHttps) {
  // unregister service worker
  const { serviceWorker } = navigator;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }
  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  });

  clearCache();
}
